export default __webpack_public_path__ + "static/media/icon-AMS.bb50f00e.svg";